import { NLProps } from "./NutritionLabel";
import { Box } from "@mui/material";
import EnvConfig from "../../../../config/env.config.json";
import { NLCard } from "../../../common/NLCard/NLCard";
import { useAppSelector } from "../../../../app/hooks";

const T2_NutritionLabel = (props: NLProps) => {
  const {
    plandata,
    selectedLine,
    priceCalculationHandler,
    tabValue,
    maxShipvalue,
    minShipvalue,
    showNutritionLabels,
    setShowNutritionLabels,
    setTabValue,
    NLContent,
    nlPlan,
  } = props;
  const { coupon } = useAppSelector((state: any) => state.checkout);
  const planPerLinesCost = priceCalculationHandler(
    nlPlan,
    selectedLine,
    coupon
  );

  return EnvConfig.IS_NUTRITION_LABEL_REQUIRED ? (
    <>
      {showNutritionLabels && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
          }}
        >
          <NLCard
            plan={nlPlan}
            {...{ planPerLinesCost, minShipvalue, maxShipvalue }}
            {...props}
          />
        </Box>
      )}
    </>
  ) : null;
};

export default T2_NutritionLabel;
